import { runWithConcurrency } from "../utilities/ConcurrencyPool";

// How many per-library or per-site requests Advanced Search keeps in flight. The lists grow with
// every ticked site - client group sites are ticked by default - and firing them all at once
// invites SharePoint throttling, whose Retry-After then releases the whole burst together again.
export const ADVANCED_SEARCH_CONCURRENCY: number = 6;

/**
 * Promise.all over `items`, running at most `limit` (at least one) at a time. Results keep the
 * input order. The first failure rejects the whole call once the items already running have
 * finished, and no further item is started.
 */
export const mapWithConcurrency = async <T, R>(items: T[], limit: number, work: (item: T, index: number) => Promise<R>): Promise<R[]> => {
  let failure: { error: any } | undefined;
  const results = await runWithConcurrency(items ?? [], async (item: T, index: number): Promise<R> => {
    try {
      return await work(item, index);
    } catch (error) {
      failure = failure ?? { error };
      throw error;
    }
  }, { concurrency: Math.max(1, Math.floor(limit) || 1), isCancelled: () => !!failure });
  if (failure) {
    throw failure.error;
  }
  return results.map(result => result.value);
};
